import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/t/home')({
  staticData: { breadcrumb: 'Home', breadcrumbKey: 'K_BREADCRUMB_HOME' },
});
